<template>
    <div>
        <contact-create
            v-if="!state.error"
            :segment="segment"
            :storePath='contactCreateStorePath'>
        </contact-create>
        <div v-else>
            {{ state.error }}
        </div>
    </div>
</template>

<script>
    import getters from '../../../utils/getters.js';
    import contactCreate from '../_contact-create.vue';

    export default {
        name: 'contact-create-page',
        components: {
            'contact-create': contactCreate,
        },
        props: {
            customer: {type: Object, required: true},  // fake to force re-rendering
        },
        data() {
            const storePath = 'worker/contactCreatePage';
            return {
                storePath,
                contactCreateStorePath: `${storePath}/contactCreate`,
                recordDetailSessionStorePath: 'worker/recordDetailSession',
            }
        },
        mounted,
        computed: {
            state() {
                return getters.getValueByPropertyName(this.$store.state, this.storePath, '/');
            },
            session() {
                return getters.getValueByPropertyName(this.$store.state, this.recordDetailSessionStorePath, '/');
            },
        },
        methods: {
            initSession,
        },
        watch: {
          '$route': initSession,
        },
    };

    function mounted() {
        this.initSession()
            .then(() => {
                return this.$store.dispatch(`${this.contactCreateStorePath}/init`);
            })
    }

    function initSession() {
        const customerId = this.customer.id;
        if (!customerId) {
            const error = 'Customer is not selected. Please select customer on data grid page.';
            this.$store.commit(`${this.storePath}/setError`, error);
            return Promise.reject();
        } else {
            return this.$store.dispatch(`${this.recordDetailSessionStorePath}/init`, this.customer);
        }
    }
</script>
